import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { McpConnector } from '@server/mcp';
import type { RootState } from '.';

interface McpConnectorsState {
  connectors: McpConnector[] | undefined;
  isLoading: boolean;
}

const initialState: McpConnectorsState = {
  connectors: undefined,
  isLoading: false,
};

export const mcpConnectorsSlice = createSlice({
  name: 'mcpConnectors',
  initialState,
  reducers: {
    setConnectors: (state, action: PayloadAction<McpConnector[]>) => {
      state.connectors = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    addConnector: (state, action: PayloadAction<McpConnector>) => {
      state.connectors = [...(state.connectors ?? []), action.payload];
    },
    removeConnector: (state, action: PayloadAction<string>) => {
      state.connectors = state.connectors?.filter((c) => c.id !== action.payload);
    },
    clearConnectorConnection: (state, action: PayloadAction<string>) => {
      state.connectors = state.connectors?.map((c) =>
        c.connectionId === action.payload ? { ...c, connectionId: undefined } : c,
      );
    },
  },
});

export const {
  setConnectors,
  setIsLoading,
  addConnector,
  removeConnector,
  clearConnectorConnection,
} = mcpConnectorsSlice.actions;

export const selectConnectors = (state: RootState) => state.mcpConnectors.connectors;
export const selectMcpConnectionsIsLoading = (state: RootState) => state.mcpConnectors.isLoading;

export default mcpConnectorsSlice.reducer;
